import { render } from "./common-header.vue?vue&type=template&id=a037a9e8&scoped=true"
import script from "./common-header.vue?vue&type=script&lang=js"
export * from "./common-header.vue?vue&type=script&lang=js"

import "./common-header.vue?vue&type=style&index=0&id=a037a9e8&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a037a9e8"]])

export default __exports__